import { useQuery } from "@tanstack/react-query";
import { instance } from "api/apiBase";
import { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useSearchParamsState } from "shared/hooks/use-search-params-state";
import { VerificationNames } from "shared/types";
import { Application } from "types/application";

export const useApplicantIdReportController = () => {
  const [searchParams, setSearchParams] = useSearchParamsState(
    {
      applicantId: "",
      report: VerificationNames.RentalApplication
    },
    ["applicantId", "report"]
  );

  const location = useLocation();

  //   get applicationId from url
  const { applicationId } = useParams();

  const queryKey = ["APPLICATION_ID_REPORT", applicationId];

  const applicationMeta = useQuery({
    queryKey,
    queryFn: () =>
      instance
        .get<
          Application | undefined
        >(`/portal/v1/applications/${applicationId}`)
        .then(({ data }) => {
          return data;
        })
  });

  useEffect(() => {
    const data = applicationMeta.data;

    const urlParams = new URLSearchParams(location.search);
    const applicantId = urlParams.get("applicantId");

    const currentApplicantId = String(
      applicationMeta.data?.applicants.find(
        (appl) => String(appl.id) === String(applicantId)
      )?.id || data?.applicants[0]?.id
    );

    const reportName = new URLSearchParams(location.search).get("report");
    // Previously was in onSuccess
    setSearchParams({
      report: reportName || "rental_application",
      applicantId: currentApplicantId
    });
  }, [applicationMeta.data]);

  useEffect(() => {
    // check is searchParams is empty
    const urlParams = new URLSearchParams(location.search);
    setSearchParams({
      applicantId: urlParams.get("applicantId") || "",
      report: urlParams.get("report") || VerificationNames.RentalApplication
    });
  }, []);

  return {
    applicationMeta,
    searchParams,
    applicationId,
    setSearchParams,
    queryKey
  };
};
